const CONFIG = {
  NAME: 'DEV',
  // BASE_API_URL: 'http://localhost:8082/api/v1',
  // BASE_CALL_URL: '',
  BASE_CALL_URL: 'http://mrs.doctor4u.vn',
  BASE_IMAGE_URL: 'http://mrs.doctor4u.vn/openmrs',
  BASE_API_URL: 'http://mrs.doctor4u.vn/openmrs/ws/rest',
};
export default CONFIG;
